<template>
  <div class="game-life">
    <div class="game-life__circle" data-circle>
      <img src="/img/misc/game-life.png" alt="Game life icon" data-icon>
    </div>

    <p class="game-life__text" v-html="$store.state.life"/>
  </div>
</template>

<script>
export default {
  name: 'GameLife',
};
</script>

<style lang="scss" scoped>
.game-life {
  position: relative;

  font-size: 18px;
  justify-content: flex-start;

  &,
  &__circle {
    display: flex;
    align-items: center;
  }

  &__circle {
    width: 36px;
    height: 36px;
    margin: 0 5px 0 0;

    border-radius: 50%;
    background-color: #F5E5E2;
    justify-content: center;

    img {
      width: 90%;
    }
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    font-size: 36px;

    &__circle {
      width: 45px;
      height: 45px;
      margin: 0 10px 0 0;
    }
  }

  @include mq(dm) {
    &__circle {
      width: 52px;
      height: 52px;
    }
  }
}
</style>
